import { FC } from "react";
import { useAccordion } from "./Accordion";
import { AccordionItemContent } from "./AccordionItemContent";
import { AccordionItemHeader } from "./AccordionItemHeader";
import classes from "./AccordionItem.module.scss";

interface Props {
  header: JSX.Element;
  content?: JSX.Element | false;
  value: any;
  className?: string;
  theme?: string;
  onChange?: () => void;
}

export const AccordionItem: FC<Props> = ({
  header,
  content,
  value,
  className,
  theme,
  onChange,
}) => {
  const { activeItem, setActiveItem } = useAccordion();
  const setActiveItemHandler = () => {
    setActiveItem(value);
    if (onChange) {
      onChange();
    }
  };

  const isActive =
    !value && activeItem === "Delivery" ? false : activeItem === value;

  return (
    <div className={classes[`${className}`]}>
      <AccordionItemHeader
        isActive={isActive}
        onChange={setActiveItemHandler}
        theme={isActive ? theme : "white"}
        value={value}
      >
        {header}
      </AccordionItemHeader>
      {isActive && content && (
        <AccordionItemContent value={activeItem} className={className}>
          {content}
        </AccordionItemContent>
      )}
    </div>
  );
};

AccordionItem.defaultProps = {
  content: undefined,
};
